"use strict";
const menuItemBase_1 = require("./menuItemBase");
/**
 * The structure for the Items of a menu
 * @class MenuItem
 */
class DefaultMenuItem extends menuItemBase_1.MenuItemBase {
    constructor(id, text = "", action = "", childs = [], parent = null) {
        super(id, text, action, childs, parent);
        this.id = id;
        this.text = text;
        this.action = action;
        this.childs = childs;
        this.parent = parent;
    }
}
exports.DefaultMenuItem = DefaultMenuItem;
